export default function PriceList({ items, testId }) {
    return (
        <ul className="divide-y divide-[#F2E1E6]" data-testid={testId}>
            {items.map((item) => (
                <li key={item.name} className="flex items-start justify-between gap-4 py-3.5" data-testid={`${testId}-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                    <div className="min-w-0">
                        <p className="text-sm sm:text-base font-semibold text-[#3D2318]">{item.name}</p>
                        {item.detail && <p className="mt-0.5 text-xs text-[#8C6A5D] leading-relaxed">{item.detail}</p>}
                    </div>
                    <p className="shrink-0 text-right leading-none">
                        <span className="font-display text-2xl font-bold text-[#C95B7D]">{item.price}</span>
                        <span className="block mt-1 text-[10px] uppercase tracking-[0.15em] text-[#8C6A5D]">{item.per}</span>
                    </p>
                </li>
            ))}
        </ul>
    );
}
